/** @format */

import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import { clearNewstError, getNewsDetail, rateNewsDetail, setNewsDetailLoading } from 'src/slices/news';
import { useDispatch, useSelector } from 'src/store';
import { ContentBlock } from '../legal-pages/contentBlock';
import { Navigate } from 'react-router-dom';
import { Rating } from 'src/components/Rating';
import { NewsDetailSkeleton } from 'src/components/news/item';
import { t } from 'i18next';

export default function NewsDetail() {
  const dispatch = useDispatch();
  const { nid } = useParams();
  const { error, globalLoading } = useSelector(state => state.global);
  const {
    newsDetail,
    newsDetailLoading,
    error: newsError,
    ratingError,
    ratingSuccess
  } = useSelector(state => state.news);

  useEffect(() => {
    if (!nid) return;
    dispatch(getNewsDetail(nid, false));
  }, [nid, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setNewsDetailLoading());
    };
  }, [dispatch]);

  const isLoading = globalLoading || newsDetailLoading;
  const { title: pageTitle, rating, ratingCount } = newsDetail || {};
  const isSameNewsDetail = Boolean(newsDetail) && newsDetail.id == Number(nid);
  const shouldDimDetail = isLoading && isSameNewsDetail;
  const shouldShowSkeleton = isLoading && !isSameNewsDetail;

  if (error || newsError || !nid) return <Navigate to="/404" replace />;
  return (
    <Page className={`archive-page news-page`} title={pageTitle}>
      <Breadcrumb
        data={[{ title: t('news.title'), link: `/news` }, { title: newsDetail?.title || '' }]}
        additionalClasses="container--narrow"
      />
      <Grid style={{ viewTransitionName: 'news-detail' }}>
        {shouldShowSkeleton ? (
          <div className="container container--narrow">
            <NewsDetailSkeleton />
          </div>
        ) : (
          <div className={`news-detail-content${shouldDimDetail ? ' news-detail-content--loading' : ''}`}>
            <Grid className="container container--narrow">
              <Grid className="archive-page-title-box">
                <h1 className="content-page-title news-page-title">{pageTitle}</h1>
              </Grid>
              <Grid className="archive-page-rating">
                <Rating rating={rating} />
                {typeof rating === 'number' && rating > -1 && (
                  <Grid className="archive-page-rating-count">
                    {rating.toFixed(1)} | {ratingCount} Ratings
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid className="archive-page-content">
              {newsDetail && (
                <ContentBlock
                  nid={nid}
                  content={newsDetail}
                  rating={rating}
                  clearError={clearNewstError}
                  rateDetail={rateNewsDetail}
                  loading={newsDetailLoading}
                  ratingError={ratingError}
                  ratingSuccess={ratingSuccess}
                  isNews={true}
                />
              )}
            </Grid>
          </div>
        )}
      </Grid>
    </Page>
  );
}
